import React, { forwardRef, useRef, useState, useEffect } from "react";
import { styled } from "@linaria/react";
import { useTheme, ITheme } from "src/theme-revamp";
import { Validations } from "@utils/helpers";
import { isEmpty } from "lodash";
// import Button from '../../Button';

// const BoxFix = styled.div<InputProps>`
//   font-size: 16px;
//   font-family: ${(props) => props.theme.fontFamily};
//   line-height: 20px;
//   font-weight: bold;
//   color: ${(props) => props.theme.colors.grey[500]};
//   background-color: ${(props) => props.theme.colors.grey[600]};
//   margin: 0;
//   padding: 13px 20px;
//   position: absolute;
//   top: ${(props) => (props.invalid ? '1px' : '1px')};
//   bottom: ${(props) => (props.invalid ? '1px' : '1px')};
//   left: ${(props) => (props.variant === 'prefix' ? '1px' : 'auto')};
//   right: ${(props) => (props.variant === 'suffix' ? '1px' : 'auto')};
//   border-radius: ${(props) =>
//     props.variant === 'prefix' ? '4px 0 0 4px' : '0 4px 4px 0'};
//   border-right: ${(props) => (props.variant === 'prefix' ? '1px' : '0px')} solid
//     ${(props) =>
//       props.invalid
//         ? props.theme.colors.red[200]
//         : props.theme.colors.grey[100]};
//   border-left: ${(props) => (props.variant === 'suffix' ? '1px' : '0px')} solid
//     ${(props) =>
//       props.invalid
//         ? props.theme.colors.red[200]
//         : props.theme.colors.grey[100]};
//   user-select: none;
//   -webkit-user-select: none;
//   -webkit-touch-callout: none;
// `;

// const Tag = styled.div<InputProps>`
//   background-color: ${(props) => props.theme.colors.grey[600]};
//   border-radius: 4px;
//   border: 1px solid ${(props) => props.theme.colors.grey[600]};
//   box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
//   -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
//   color: ${(props) => props.theme.colors.primary};
//   font-size: 14px;
//   font-family: ${(props) => props.theme.fontFamily};
//   line-height: 20px;
//   margin: 0;
//   padding: 4px 30px 4px 10px;
//   position: absolute;
//   top: 10px;
//   left: 10px;
//   user-select: none;
//   -webkit-user-select: none;
//   -webkit-touch-callout: none;
// `;

// const Cross = styled.div<InputProps>`
//   cursor: pointer;
//   display: inline-block;
//   font-family: ${(props) => props.theme.fontFamily};
//   font-size: 28px;
//   transform: rotate(45deg);
//   position: absolute;
//   top: 4px;
//   right: 9px;
//   user-select: none;
//   -webkit-user-select: none;
//   -webkit-touch-callout: none;
// `;

const InputElement = styled.input<InputProps>`
  background-color: transparent;
  border: none;
  border-bottom: ${(props) =>
    props.readOnly && !props.swap
      ? "0"
      : props.invalid
      ? "1px solid #C50000"
      : "1px solid #C4C4C4"};
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  color: ${(props) =>
    props.readOnly
      ? props.readOnlyColor || "#000"
      : props.color
      ? props.color
      : props?.theme?.colors?.primary || "#883e89"};
  flex-grow: 0;
  font-family: ${(props) => props.theme.fontFamily};
  font-size: ${(props) => (props.variant === "slider" ? "28px" : "14px")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
  letter-spacing: -0.1px;
  line-height: 1.4;
  margin: 0;
  max-height: 50px;
  opacity: ${(props) => (props.disabled ? "0.3" : "1")};
  outline: 0;
  padding: ${(props) =>
    props.padding
      ? typeof props.padding === "number"
        ? props.padding + "px"
        : props.padding + ""
      : props.mobCode
      ? "0 0 8px 27px"
      : "0 0 8px 0"};
  transition: border-color 0.18s linear;
  width: 100%;
  min-width: ${(props) => (props.minWidth ? props.minWidth + "px" : "auto")};
  -webkit-appearance: none;
  text-align: ${(props) => props.textAlign || "unset"};
  &::placeholder {
    font-weight: 400;
    color: ${(props) => props.theme.colors.grey[1500]};
    transition: color default;
  }
  text-transform: ${(props) => props.textTransform || "none"};
  border-radius: 0;
  &:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: ${(props) =>
      props.color
        ? props.color
        : props?.theme?.colors?.primary || "#883e89"} !important;
    font-size: 16px;
    font-weight: 600;
  }
`;

const Container = styled.div<StyledProps>`
  display: ${(props) =>
    props.variant === "button" || props.mobCode
      ? "flex"
      : props.variant === "inline"
      ? "inline-block"
      : "block"};
  padding: 0;
  width: ${(props) =>
    props.variant === "inline"
      ? "auto"
      : props.variant === "slider"
      ? "192px"
      : "100%"};
  position: relative;
  margin: ${(props) =>
    props.margin
      ? typeof props.margin === "number"
        ? `${props.margin}px`
        : props.margin
      : "unset"};
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

const MobCode = styled.span`
  color: #c9c9c9;
  font-weight: 600;
  position: absolute;
  line-height: 1.4;
  font-size: 14px;
`;

interface StyledProps {
  variant?: string;
  isFocus?: boolean;
  inValid?: boolean;
  margin?: string | number;
  theme?: ITheme;
  mobCode?: string;
}
export interface InputProps {
  variant?: "default" | "inline" | "slider";
  invalid?: boolean;
  inline?: boolean;
  theme?: any;
  themes?: ITheme; //added this to address the color not found error
  buttonLabel?: string;
  boxLabel?: string;
  inputMode?:
    | "numeric"
    | "decimal"
    | "search"
    | "text"
    | "none"
    | "email"
    | "tel"
    | "url";
  // Built in attr
  disabled?: boolean;
  placeholder?: string;
  value?: string | number | string[];
  margin?: number | string;
  padding?: number | string;
  typeInput?: React.HTMLInputTypeAttribute | undefined;
  type?: "normal" | "numeric" | "number" | "alphanumeric" | "decimal";
  name?: string;
  id?: string;
  pattern?: string;
  max?: string;
  min?: string;
  minLength?: number;
  maxLength?: number;
  fontWeight?: number | string;
  minWidth?: number;
  onChange?: (e: any) => void;
  onFocus?: (e: any) => void;
  onBlur?: (e: any) => void;
  onButtonClick?: (e: any) => void;
  onClearTag?: (e: string, index?: number) => void;
  ref?: any;
  textAlign?: "center" | "left" | "right";
  readOnly?: boolean;
  readOnlyColor?: string;
  textTransform?: string;
  color?: string;
  bgColor?: string;
  swap?: string;
  mobCode?: string;
  autoComplete?: "off" | "on";
}

const Input = forwardRef<HTMLDivElement, InputProps>(
  (
    {
      variant = "default",
      buttonLabel = "Demo",
      boxLabel,
      placeholder,
      margin = "0 0 30px 0",
      value,
      name = "",
      type,
      color,
      bgColor,
      onChange,
      onFocus,
      onBlur,
      invalid,
      onClearTag,
      onButtonClick,
      readOnly,
      readOnlyColor,
      swap,
      mobCode,
      typeInput,
      ...props
    }: InputProps,
    ref
  ) => {
    let theme = useTheme();
    const inputRef = useRef<HTMLInputElement>(null);
    const [isFocus, setFocus] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<
      string | number | string[] | undefined
    >(value);

    if (props.themes) {
      theme = props.themes;
    }

    const handleChange = (event: any): void => {
      const value = event.target.value;
      // console.log('Input ➤ handleChange', { value, inputValue });

      if (
        !isEmpty(value) &&
        type === "decimal" &&
        !Validations.isDecimal(value)
      ) {
        // console.log('Input ➤ handleChange ➤ decimal check', { empty: !isEmpty(value), validation: !Validations.isDecimal(value) });
        setInputValue(inputValue);
        return;
      }
      if (
        !isEmpty(value) &&
        (type === "number" || type === "numeric") &&
        !Validations.isNumeric(value)
      ) {
        // console.log('Input ➤ handleChange ➤ numeric check', { empty: !isEmpty(value), validation: !Validations.isNumeric(value) });
        setInputValue(inputValue);
        return;
      }
      if (
        !isEmpty(value) &&
        type === "alphanumeric" &&
        !Validations.isAlphanumeric(value)
      ) {
        // console.log('Input ➤ handleChange ➤ alphanumeric check', { empty: !isEmpty(value), validation: !Validations.isAlphanumeric(value) });
        setInputValue(inputValue);
        return;
      }
      setInputValue(value);
      if (onChange) {
        onChange(event);
      }
    };

    const handleBlur = (event: any): void => {
      setFocus(false);
      if (onBlur) {
        onBlur(event);
      }
    };

    const handleFocus = (event: any): void => {
      setFocus(true);
      if (onFocus) {
        onFocus(event);
      }
    };

    useEffect(() => {
      // console.log('Input ➤ useEffect', { value, inputValue });
      if (value !== inputValue) {
        setInputValue(value);
      }
    }, [setInputValue, value, inputValue]);

    return (
      <Container
        variant={variant}
        margin={margin}
        isFocus={isFocus}
        theme={theme}
        inValid={invalid}
        mobCode={mobCode}
      >
        <React.Fragment>
          {mobCode && <MobCode>{mobCode}</MobCode>}
          <InputElement
            type={(typeInput as unknown as any) || type}
            ref={ref}
            name={`${name}`}
            value={`${inputValue}`}
            variant={variant}
            placeholder={placeholder}
            theme={theme}
            color={color}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            invalid={invalid}
            readOnly={readOnly}
            readOnlyColor={readOnlyColor}
            swap={swap}
            mobCode={mobCode}
            style={{ backgroundColor: bgColor }}
            {...props}
          />
        </React.Fragment>
      </Container>
    );
  }
);

Input.defaultProps = {
  value: "",
  onChange: () => {},
};
export { Input };
